import { api } from "../../services/index";

const kanban_cards = {
  // namespaced:true,
  state: {
    data: [],
    gains: [],
    pagination:[],
    modals: {
      new_card: false,
      new_card_from_chat: false,
      edit_card: false,
      edit_card_from_chat: false,
      view_card_from_chat: false,
      mark_as_loss: false,
      mark_as_loss_from_chat: false,
      mark_as_gain: false,
      add_product_to_card: false,
      add_product_to_card_from_chat: false,
      confirm_delete: false,
      confirm_delete_from_chat: false,
      add_task: false,
    },
    new_card: {
      name: null,
      expiration: null,
      expiration_at: null,
      description: null,
      price: 0,
      selected_products: [],
      contact_infos: {
        phone: null,
        name: null,
      },
      pipeline_infos: {
        id: 0,
        name: null,
        color: null
      }
    },
    current_card: {
      name: null,
      user_id: null,
      expiration: null,
      expiration_at: null,
      description: null,
      price: 0,
      selected_products: [],
      included_products: [],
      contact_infos: {
        phone: null,
        name: null,
      },
      pipeline_infos: {
        id: 0,
        name: null,
        color: null
      },
      included_tasks: []
    },
    model_current_card: {
      name: null,
      user_id: null,
      expiration: null,
      expiration_at: null,
      description: null,
      price: 0,
      selected_products: [],
      included_products: [],
      contact_infos: {
        phone: null,
        name: null,
      },
      pipeline_infos: {
        id: 0,
        name: null,
        color: null
      },
      included_tasks: []
    },
    creating_card: false,
    editing_card: false,
    edit_card: {
      name: null,
      expiration: null,
      expiration_at: null,
      description: null,
      price: 0,
      selected_products: [],
      contact_infos: {
        phone: null,
        name: null,
      },
      pipeline_infos: {
        id: 0,
        name: null,
        color: null
      }
    }
  },
  mutations: {
    // SET_COLUMNS_VALUE(state, payload) {
    //   state.data = payload;
    // }
    SET_KANBAN_CARDS_LEAD(state, payload){
      state.pagination = payload;
    }
  },
  actions: {
    newCard(context, card_infos) {
      api.post('/kanban/cards', card_infos).then((response) => {
        context.rootState.kanban_cards.modals.new_card = false;
        context.rootState.kanban_cards.current_card = context.rootState.kanban_cards.model_current_card;
        context.dispatch('getAllColumns', context.rootState.kanban_columns.fields_search);
      })
    },
    newCardFromChat(context, card_infos) {
      api.post('/kanban/cards', card_infos).then((response) => {
        context.rootState.kanban_cards.modals.new_card_from_chat = false;
        context.rootState.kanban_cards.current_card = context.rootState.kanban_cards.model_current_card;
        context.dispatch('getLeadCardsFromChat', card_infos);
      })
    },
    editCard(context, card_infos) {
      api.put(`/kanban/cards/${card_infos.id}`, card_infos).then((response) => {
        context.rootState.kanban_cards.modals.edit_card = false;
        context.rootState.kanban_cards.current_card = context.rootState.kanban_cards.model_current_card;
        context.dispatch('getAllColumns', context.rootState.kanban_columns.fields_search);
      })
    },

    editCardFromChat(context, card_infos) {
      api.put(`/kanban/cards/${card_infos.id}`, card_infos).then((response) => {
        context.rootState.kanban_cards.modals.edit_card_from_chat = false;
        context.rootState.kanban_cards.current_card = context.rootState.kanban_cards.model_current_card;
        context.dispatch('getLeadCardsFromChat', card_infos);//context.dispatch('getAllColumns', context.rootState.kanban_columns.fields_search);
      })
    },
    
    deleteCard(context, card_infos){
      api.delete(`kanban/cards/${card_infos.id}`).then(response => {
        context.dispatch('getAllColumns', context.rootState.kanban_columns.fields_search);
      }).catch(() => {
        this.deleting_card = false;
      }) 
    },
    
    deleteCardFromChat(context, card_infos){
      api.delete(`kanban/cards/${card_infos.id}`).then(response => {
        context.dispatch('getLeadCardsFromChat', card_infos);
      }).catch(() => {
        this.deleting_card = false;
      }) 
    },
    getLeadCardsFromChat(context, payload) {
      const channel_id = payload.channel_id;
      const department_id = payload.department_id;
      api.get(`kanban/cards`, {
        params: {
          channel_id: payload.channel_id,
          department_id: payload.department_id,
          lead_id: payload.lead_id,
          stage_key: 0,
          user_id: context.rootState.me.data.id
        }
      }).then(response => {
          //context.commit("SET_COLUMNS_VALUE", response.data);
          context.rootState.kanban_cards.data = response.data.data;
      });
    },
    getLeadCards(context, payload){
      api.get(`kanban/cards`, {
        params: {
          channel_id: payload.channel_id,
          //department_id: payload.department_id,
          lead_id: payload.lead_id,
          //stage_key: 0,
          //user_id: context.rootState.me.data.id
        }
      }).then((response) => {
        context.commit("SET_KANBAN_CARDS_LEAD", response.data);
      })
    }
  }
};
export default kanban_cards;
